import React from 'react'
import styled from 'styled-components'
import { Button, DropdownMenu, Flex, Text } from '@radix-ui/themes'
import { useAuth } from '../auth'


export const Header: React.FC = () => {
  const { user, logout, redirectToAuth } = useAuth()

  return (
    <StyledWrapper align="center" direction="row" gap="4" py="1" px="3">
      <img className="logo" src="/miigu-logo.png" alt=""/>
      <Flex direction="column">
        <Text size="2" weight="bold">Электронная библиотека АННИО «МИИГУ им. П.А. Столыпина»</Text>
        <Text size="1">Электронная библиотечная система «Килиманджаро»</Text>
      </Flex>
      <Flex flexGrow="1"/>
      {
        user ? <>
          <DropdownMenu.Root>
            <DropdownMenu.Trigger>
              <Button variant="soft">
                {user.email}
                <DropdownMenu.TriggerIcon/>
              </Button>
            </DropdownMenu.Trigger>
            <DropdownMenu.Content>
              <DropdownMenu.Item onClick={logout}>Выйти</DropdownMenu.Item>
            </DropdownMenu.Content>
          </DropdownMenu.Root>
        </> : <>
          <Button variant="solid" onClick={redirectToAuth}>Войти</Button>
        </>
      }
    </StyledWrapper>
  )
}

const StyledWrapper = styled(Flex)`
  background-color: 1px solid var(--gray-4);
  border-bottom: 1px solid var(--gray-6);

  .logo {
    width: 48px;
    height: 48px;
  }
`
